import { RequestServices } from '../services/request.service';
import { Configuration } from '../Constants/configuration';
import { StorageService } from '../services/storage.service';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { Vehiculo } from '../modelos/data-emision.model';

export class validaSerie {
    public vehiculo: Vehiculo = new Vehiculo();
    private subject = new Subject<any>();
    public const: Configuration = new Configuration();
    public logConsumoId: string = "";
    public cocheSeguro: CocheSeguro = new CocheSeguro();
    public validacionSerie: boolean = false;

    constructor(
        private requestService?: RequestServices,
        private storageService?: StorageService,
        private router?: Router
    ) { }


    validaNoSerie(num?): Observable<any> {
        try {

            let cocheSeguro: CocheSeguro = new CocheSeguro();
            this.vehiculo = cocheSeguro?.vehiculo;
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));

            let negId: number = parseInt(sessionStorage.getItem("negId"));

            let parameters: any = {
                "negocio_id": negId,
                "cia": cocheSeguro.cia,
                "serie": num,
                "params": {
                    "cot_id": cocheSeguro.cot_id
                }
            };
            this.requestService.postRequest({ projectName: new Configuration().URLQUATTROAUTOSWS, apiName: "consulta-serie", dataJSON: parameters }).subscribe(result => {
                if (result.ok == true) {
                    this.subject.next(result);
                } else if (result.error) {
                    this.subject.next(result.error);
                    console.error("requestService.getValidacionSerie", result.error);
                } else {
                    this.subject.next(result);
                    console.error("else.getValidacionSerie", result);
                }
            });
        } catch (error) {
            this.subject.next(error);
            console.error(error);
        }
        return this.subject.asObservable();
    }
}
